import { gql } from 'graphql-tag';

export default gql`
    fragment RichTextBlockFragment on RichTextBlock {
        blockName
        blockType
        richText
    }
`;
